import Vue from 'vue'


export const money = (value: string|number, suffix = ',-') => {
    value = Number(value).toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR',
    })

    value = value.replace(',00', '')
    value = `${value}${suffix}`

    return value
}
Vue.filter('money', money)

export const money_short = (value: string|number) => {
    value = Number(value)

    const tierSuffixes = ['', 'K', 'M']
    const tier = Math.max(Math.min(Math.floor(Math.log10(value) / 3), tierSuffixes.length - 1), 0)
    const suffix = tierSuffixes[tier]

    value = value / Math.pow(10, tier * 3)

    return Number(value).toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0,
    }) + suffix
}
Vue.filter('money_short', money_short)


export const fixed = (value: number, digits = 0) => {
    return value.toFixed(digits)
}
Vue.filter('fixed', fixed)


export const percentage = (value: number, maximumDigits = 0) => {
    return Number(value).toLocaleString('nl-NL', {
        style: 'percent',
        maximumFractionDigits: maximumDigits,
    })
}
Vue.filter('percentage', percentage)

